const Header = () => {
  return (
    <header className="header">
      <img src="logo512.png" alt="React logo" />
      <h1>React Quiz</h1>
    </header>
  );
};

export default Header;
